const getSearchProvider = (modelId) => {
  const storage = sessionStorage.getItem(`ABTest_SE_${modelId}`);
  let provider = null;
  if (storage){
    provider = JSON.parse(storage).provider;
  }
  return provider;
};

export const initSearchEngineTestABfuntions = () => {
  const modelId = document.querySelector('#models-information').dataset.productId;
  const provider = getSearchProvider(modelId);
  if (provider) {
    jQuery('body').on('click','#ctaButton.dkti-cart', () => {
      window.cube.analytics.sendEvent(this, 'NavigationEvent','TestBuscadorInterno', 'Interes', 'añadirAlaCesta');
    });
    jQuery('body').on('click','.buying-zone__tab-label--store', () => {
      window.cube.analytics.sendEvent(this, 'NavigationEvent','TestBuscadorInterno', 'Interes', 'inicioRapido');
    });
    jQuery('body').on('click','.js-open-store-selector', () => {
      window.cube.analytics.sendEvent(this, 'NavigationEvent','TestBuscadorInterno', 'Interes', 'verStockEnTienda');
    });
  }
};



// WEBPACK FOOTER //
// ./src/_override/shared/pdp/search-testAB/search.testAB.js